import styled from 'styled-components';

export const MountainSearchStyles = styled('div')`
  background: white;
  padding: 1.5rem 1rem;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.neutrals['200']};

  .explain {
    text-align: center;
    font-size: 1.25rem;
  }

  .or {
    text-align: center;
    display: block;
    padding: 1rem 0;
    position: relative;
    z-index: 1;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      height: 1px;
      background: #dadada;
      z-index: -1;
    }
    span {
      padding: 0 1rem;
      background: white;
    }
  }

  .mountain-item {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    background: ${({ theme }) => theme.neutrals['200']};
    margin: 0.5rem 0.5rem 0 0;
    font-size: 0.8rem;
    color: black;
    text-decoration: none;
    border-radius: 8px;
    transition: all 150ms;

    &:hover {
      background: ${({ theme }) => theme.neutrals['300']};
    }
  }
`;
